@if (showLoader()) {
  @if (isV3()) {
    <app-v3-loading-screen
      (minDurationElapsed)="onV3LoadingScreenElapsed()"
    ></app-v3-loading-screen>
  } @else {
    <app-loader [isDelayed]="true"></app-loader>
  }
} @else {
  @if (timedOut()) {
    <app-background>
      <div class="main-section">
        <app-timed-out (navClick)="parentGoBack()"></app-timed-out>
      </div>
    </app-background>
  }

  <!-- No ISIN fallback -->
  @if (!isin() && !timedOut()) {
    <app-loader [isDelayed]="true"></app-loader>
  }

  <!-- ISIN page -->
  @if (isin() && !timedOut()) {
    <app-background [skipSafeAreaTop]="showMobileFinanzenHeader()">
      @if (isV3()) {
        <app-v3-root
          [stockName]="stockName()"
          [stockLogo]="stockLogo()"
          [price]="(price$ | async)?.[priceIsin() || '']?.bid"
          [prevPrice]="(prevQuote$ | async)?.[priceIsin() || '']?.[0]?.bid"
          [isMainPage]="section() === 'main'"
          [isInfoPage]="section() === 'info'"
          [showInfoButton]="showInfoButton()"
          [pageTitle]="activeTabTitle()"
          [pageIcon]="pageIcon()"
          [updatedAt]="subpageUpdatedAt()"
          [activeTab]="activeTab()"
          [tabs]="v3VisibleTabs()"
          [companyAvailable]="!!companyAnalysis()"
          [showRegwall]="showRegwall()"
          (companyClicked)="goToCompanyAnalysis()"
          (subpageBackClicked)="onSubpageBack()"
          (closeClicked)="parentGoBack()"
          (tabChange)="onTabChange($event)"
          (infoClicked)="openInfoPage()"
        >
          @if (section() === 'main') {
            <app-v3-overview
              [currentPrice]="(price$ | async)?.[priceIsin() ?? '']?.bid ?? null"
              [livePrices]="(livePrices$ | async) ?? null"
              (navigate)="onScoresNavigate($event)"
              (navigateNews)="setAnalyse('news')"
              (navigateAnalysts)="setAnalyse('market_analyst_sentiment')"
              (navigateCompetitor)="setAnalyse('competitive')"
              (navigateEarnings)="setAnalyse('earnings')"
              (navigateToInstrument)="navigateToInstrument($event)"
            ></app-v3-overview>
          } @else if (section() === 'analyse' && analyseType() === 'action') {
            <app-v3-company-profile></app-v3-company-profile>
          } @else if (section() === 'analyse' && analyseType() === 'news') {
            <app-v3-news-analysis></app-v3-news-analysis>
          } @else if (section() === 'analyse' && analyseType() === 'earnings') {
            <app-v3-earnings-analysis></app-v3-earnings-analysis>
          } @else if (section() === 'analyse' && analyseType() === 'market_analyst_sentiment') {
            <!-- Desktop (Zero + finnetWeb) is V3AnalystsDesktopContent; mobile has its own full
                 content (Rating Konsens, Kursziele, Argumente & Thesen, Thesen) — see
                 V3AnalystsAnalysis's CLAUDE.md. -->
            <app-v3-analysts-analysis
              [currentPrice]="(price$ | async)?.[priceIsin() ?? '']?.bid ?? null"
            ></app-v3-analysts-analysis>
          } @else if (section() === 'analyse' && analyseType() === 'fundamental_scores') {
            <app-v3-fundamental-scores-analysis
              [initialCategory]="selectedScoreCategory()"
            ></app-v3-fundamental-scores-analysis>
          } @else if (section() === 'analyse' && analyseType() === 'competitive') {
            <app-v3-competitor-analysis
              [livePrices]="(livePrices$ | async) ?? null"
              (navigateToInstrument)="navigateToInstrument($event)"
            ></app-v3-competitor-analysis>
          } @else if (section() === 'info') {
            <app-v3-info-page
              [tab]="analyseType()"
              [title]="activeTabTitle()"
              [icon]="pageIcon()"
            ></app-v3-info-page>
          }
        </app-v3-root>
      } @else {
        @if (showMobileFinanzenHeader()) {
          <app-finanzen-header
            [style.paddingTop.px]="18 + safeAreaTop()"
            (closeClicked)="parentGoBack()"
          ></app-finanzen-header>
        }
        <!-- Main Section -->
        @if (section() === 'main') {
          <div class="main-section">
            @if (!responsive.isMobile()) {
              @if (!isFinnet()) {
                <app-finanzen-header (closeClicked)="parentGoBack()"></app-finanzen-header>
              }
              <div class="content-wrapper" [class.with-finanzen-header]="!isFinnet()">
                @if (isFeedbackEnabled() && !isGuestMode()) {
                  <app-survey-banner></app-survey-banner>
                }
                <div class="nav-header-wrapper">
                  <app-nav-bar
                    [name]="stockName()"
                    (companyClick)="goToCompanyAnalysis()"
                    [isin]="isin()"
                    [price]="(price$ | async)?.[priceIsin() || '']?.bid"
                    [prevPrice]="(prevQuote$ | async)?.[priceIsin() || '']?.[0]?.bid"
                    [showCompanyLink]="!!companyAnalysis()"
                  ></app-nav-bar>
                  <app-tab-navigation
                    [activeTab]="activeTab()"
                    [tabs]="visibleTabs()"
                    (tabChange)="onTabChange($event)"
                  ></app-tab-navigation>
                </div>

                <ng-container [ngTemplateOutlet]="mainContent"></ng-container>
              </div>
            } @else {
              @if (isFeedbackEnabled() && !isGuestMode()) {
                <app-survey-banner></app-survey-banner>
              }
              @if (!isFinnet()) {
                <app-nav-bar
                  [name]="stockName()"
                  (companyClick)="goToCompanyAnalysis()"
                  [isin]="isin()"
                  [price]="(price$ | async)?.[priceIsin() || '']?.bid"
                  [prevPrice]="(prevQuote$ | async)?.[priceIsin() || '']?.[0]?.bid"
                  [showCompanyLink]="!!companyAnalysis()"
                ></app-nav-bar>
              }

              <ng-container [ngTemplateOutlet]="mainContent"></ng-container>
            }

            <app-v2-disclaimer></app-v2-disclaimer>
          </div>
        }

        <!-- Analyse Section -->
        @if (section() === 'analyse') {
          <div class="main-section">
            @if (!responsive.isMobile()) {
              @if (!isFinnet()) {
                <app-finanzen-header (closeClicked)="parentGoBack()"></app-finanzen-header>
              }
              <div class="content-wrapper" [class.with-finanzen-header]="!isFinnet()">
                @if (isFeedbackEnabled() && !isGuestMode()) {
                  <app-survey-banner [isSubpage]="true"></app-survey-banner>
                }
                <div class="nav-header-wrapper">
                  <app-nav-bar
                    [name]="stockName()"
                    (companyClick)="goToCompanyAnalysis()"
                    [analyseType]="analyseType()"
                    [isin]="isin()"
                    [price]="(price$ | async)?.[priceIsin() || '']?.bid"
                    [prevPrice]="(prevQuote$ | async)?.[priceIsin() || '']?.[0]?.bid"
                  ></app-nav-bar>
                  <app-tab-navigation
                    [activeTab]="activeTab()"
                    [tabs]="visibleTabs()"
                    (tabChange)="onTabChange($event)"
                  ></app-tab-navigation>
                </div>
                <div class="bodyContainer">
                  <ng-container [ngTemplateOutlet]="analyseContent"></ng-container>
                </div>
              </div>
            } @else {
              @if (isFeedbackEnabled() && !isGuestMode()) {
                <app-survey-banner [isSubpage]="true"></app-survey-banner>
              }
              @if (responsive.isMobile() && !isFinnet()) {
                <app-back-navigation-bar (backClick)="backToMain()"></app-back-navigation-bar>
              } @else {
                <app-nav-bar
                  [name]="stockName()"
                  (companyClick)="goToCompanyAnalysis()"
                  [analyseType]="analyseType()"
                  [isin]="isin()"
                  [price]="(price$ | async)?.[priceIsin() || '']?.bid"
                  [prevPrice]="(prevQuote$ | async)?.[priceIsin() || '']?.[0]?.bid"
                ></app-nav-bar>
              }
              <div class="bodyContainer" [class.v2-mobile-card]="responsive.isMobile()">
                <ng-container [ngTemplateOutlet]="analyseContent"></ng-container>
              </div>
            }

            <app-v2-disclaimer></app-v2-disclaimer>
          </div>
        }
      }
    </app-background>
  }

  @if (!isGuestMode()) {
    @if (isV3()) {
      <!-- Not over the error page — dismissing it there would burn the show-once key (AI-640). -->
      @if (!timedOut()) {
        <app-v3-onboarding-modal (cancelled)="parentGoBack()"></app-v3-onboarding-modal>
      }
      @if (isin() && !timedOut()) {
        <app-v3-chat-widget></app-v3-chat-widget>
      }
    } @else {
      <app-mobile-welcome-modal [isAsset]="!!isin()"></app-mobile-welcome-modal>
    }
  }
}

<!-- ─── Templates ─────────────────────────────────────────────────────────── -->

<ng-template #mainContent>
  <div class="bodyContainer analyseContainer v2">
    @if (loading()) {
      <app-loader></app-loader>
    } @else {
      @if (newsAnalysis()) {
        @defer (when !loading()) {
          <app-news-overview
            [news]="newsAnalysis()"
            (navigate)="setAnalyse('news')"
          ></app-news-overview>
        }
      }
      <div class="regwall-overview-wrapper">
        @if (analystsAnalysis()) {
          @defer (when !loading()) {
            <app-analysts-overview
              [analysts]="analystsAnalysis()"
              [currentPrice]="(price$ | async)?.[priceIsin() ?? '']?.bid ?? null"
              (navigate)="setAnalyse('market_analyst_sentiment')"
            ></app-analysts-overview>
          }
        }
        @if (earningsAnalysis()) {
          @defer (when !loading()) {
            <app-earnings-overview
              [earnings]="earningsAnalysis()"
              (navigate)="setAnalyse('earnings')"
            ></app-earnings-overview>
          }
        }
        @if (isTraderfoxEnabled() && (isGuestMode() || hasFundamentalScoresRating())) {
          @defer (when !loading()) {
            <app-fundamental-scores-overview
              [fundamentalScoresContent]="fundamentalScoresRaw()"
              [name]="stockName()"
              (navigate)="setAnalyse('fundamental_scores')"
            ></app-fundamental-scores-overview>
          }
        }
        @defer (when !loading()) {
          <app-competitor-analysis
            [competition]="competitionAnalysis()"
            [livePrices]="(livePrices$ | async) ?? null"
            (navigateToInstrument)="navigateToInstrument($event)"
          ></app-competitor-analysis>
        }
      </div>
      @if (isGuestMode() && isFinnetApp()) {
        <app-regwall-info></app-regwall-info>
      }
    }
  </div>
</ng-template>

<ng-template #analyseContent>
  @switch (analyseType()) {
    @case ('news') {
      @defer (when analyseType() === 'news') {
        <app-news-analysis-v2
          [news]="newsAnalysis()"
          [showBackButton]="isFinnet() && responsive.isMobile()"
          (backClicked)="backToMain()"
        ></app-news-analysis-v2>
      } @placeholder (minimum 500ms) {
        <app-loader></app-loader>
      }
    }
    @case ('earnings') {
      @defer (when analyseType() === 'earnings') {
        <app-earnings-analysis-v2
          [earnings]="earningsAnalysis()"
          [earningsTranscripts]="earningsTranscriptsAnalysis()"
          [showBackButton]="isFinnet() && responsive.isMobile()"
          (backClicked)="backToMain()"
        ></app-earnings-analysis-v2>
        @if (isGuestMode()) {
          <app-regwall-info></app-regwall-info>
        }
      } @placeholder (minimum 500ms) {
        <app-loader></app-loader>
      }
    }
    @case ('market_analyst_sentiment') {
      @defer (when analyseType() === 'market_analyst_sentiment') {
        <app-analysts-analysis-v2
          [analysts]="analystsAnalysis()"
          [currentPrice]="(price$ | async)?.[priceIsin() ?? '']?.bid ?? null"
          [showBackButton]="isFinnet() && responsive.isMobile()"
          (backClicked)="backToMain()"
        ></app-analysts-analysis-v2>
        @if (isGuestMode()) {
          <app-regwall-info></app-regwall-info>
        }
      } @placeholder (minimum 500ms) {
        <app-loader></app-loader>
      }
    }
    @case ('fundamental_scores') {
      @defer (when analyseType() === 'fundamental_scores') {
        <app-fundamental-scores-analysis-v2
          [fundamentalScoresContent]="fundamentalScoresRaw()"
          [name]="stockName()"
          [showBackButton]="isFinnet() && responsive.isMobile()"
          (backClicked)="backToMain()"
        ></app-fundamental-scores-analysis-v2>
        @if (isGuestMode()) {
          <app-regwall-info></app-regwall-info>
        }
      } @placeholder (minimum 500ms) {
        <app-loader></app-loader>
      }
    }
    @default {
      <app-analyse-body
        [analyseType]="analyseType()"
        [isin]="isin()"
        [showBackButton]="isFinnet() && responsive.isMobile()"
        (backClicked)="backToMain()"
      >
      </app-analyse-body>
    }
  }
</ng-template>
